import { render, staticRenderFns } from "./Avaliacoes.vue?vue&type=template&id=2e660357"
import script from "./Avaliacoes.vue?vue&type=script&lang=js"
export * from "./Avaliacoes.vue?vue&type=script&lang=js"
import style0 from "./Avaliacoes.vue?vue&type=style&index=0&id=2e660357&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports